import script from "./bottomBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./bottomBar.vue?vue&type=script&setup=true&lang=ts"

import "./bottomBar.vue?vue&type=style&index=0&id=69276373&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69276373"]])

export default __exports__